import React, { useState, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useMediaQuery } from "@mui/material";
import { useSnackbar } from "notistack";
import {
  Typography,
  Divider,
  Drawer,
  Box,
  TextField,
  IconButton,
} from "@mui/material";
import {
  RestartAlt as RestartAltIcon,
  Close as CloseIcon,
} from "@mui/icons-material";
import UnicornLoading from "../../../assets/loading.gif";
import ButtonBlue from "../../../shared/buttonBlue/index.js";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import PlacesAutoComplete from "./placesAutoComplete.js";
import SiteService from "../../../../../services/site.service.js";
const DrawerSiteLocation = ({
  isOpen,
  onClose,
  setAllSiteLocations,
  setIsSiteLocationDrawerOpen,
  siteName,
  idSite,
  loc,
  selectedCompanyId,
  selectedCompany,
  isLoaded,
  isEditSiteLocation,
}) => {
  const isDrawerFullWidthScreen = useMediaQuery((theme) =>
    theme.breakpoints.down("sm")
  );
  const { control, setValue, getValues, reset, watch } = useForm({
    defaultValues: {
      site: "",
      siteName: "",
      idSite: "",
      siteCode: "",
      company: "",
      idCompany: "",
      lat: "",
      lng: "",
    },
  });
  const { enqueueSnackbar } = useSnackbar();
  const [location, setLocation] = useState({
    lat: 0,
    lng: 0,
  });
  const [geolocationStatus, setGeoLocationStatus] = useState("");
  useEffect(() => {
    if (!isEditSiteLocation) {
      setValue("site", siteName);
      setValue("company", selectedCompany);
      setValue("idCompany", selectedCompanyId);
    } else if (isEditSiteLocation && loc) {
      setValue("site", siteName);
      setValue("company", selectedCompany);
      setValue("idCompany", selectedCompanyId);
      setValue("siteName", loc.nameSite || "");
      setValue("siteCode", loc.codeSite || "");
      setLocation({
        lat: parseFloat(loc.Lat) || 0,
        lng: parseFloat(loc.Lng) || 0,
      });
    }
  }, [isOpen]);
  useEffect(() => {
    if (!isOpen) {
      reset();
    }
  }, [isOpen, reset]);

  const handleSaveSiteLocation = async () => {
    const formData = getValues();

    if (isEditSiteLocation) {
      try {
        const res = await SiteService.setSiteLocation({
          nameSite: formData.siteName,
          codeSite: formData.siteCode,
          Lat: formData.lat,
          Long: formData.lng,
          lastUpdate: new Date().toISOString(),
          idScgSite: loc.idScgSite,
        });
        if (res.data) {
          setIsSiteLocationDrawerOpen(false);
          const resAllSites = await SiteService.getAllSiteLocations(
            selectedCompanyId
          );
          setAllSiteLocations(resAllSites.data);
          enqueueSnackbar("บันทึกข้อมูลสำเร็จ", { variant: "success" });
        } else {
          enqueueSnackbar("บันทึกข้อมูลล้มเหลว", { variant: "error" });
        }
      } catch (error) {
        enqueueSnackbar("เกิดข้อผิดพลาดในการบันทึก", { variant: "error" });
      }
    } else {
      try {
        const res = await SiteService.addSiteLocation({
          noSite: formData.site,
          idSite: loc.idSite,
          nameSite: formData.siteName,
          idSite: idSite,
          codeSite: formData.siteCode,
          company: formData.company,
          idCompany: formData.idCompany,
          Lat: formData.lat,
          Long: formData.lng,
          lastUpdate: new Date().toISOString(),
        });
        if (res.data) {
          setIsSiteLocationDrawerOpen(false);
          const resAllSites = await SiteService.getAllSiteLocations(
            selectedCompanyId
          );
          setAllSiteLocations(resAllSites.data);
          enqueueSnackbar("บันทึกข้อมูลสำเร็จ", { variant: "success" });
        } else {
          enqueueSnackbar("บันทึกข้อมูลล้มเหลว", { variant: "error" });
        }
      } catch (error) {
        enqueueSnackbar("เกิดข้อผิดพลาดในการบันทึก", { variant: "error" });
      }
    }
  };
  const handleMapClick = (event) => {
    setLocation({
      lat: parseFloat(event.latLng.lat()),
      lng: parseFloat(event.latLng.lng()),
    });
  };
  const [reloadMap, setReloadMap] = useState(false);
  useEffect(() => {
    if (isOpen) {
      if (!isEditSiteLocation) {
        if ("geolocation" in navigator) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              setLocation({
                lat: parseFloat(position.coords.latitude),
                lng: parseFloat(position.coords.longitude),
              });
              setGeoLocationStatus("success");
            },
            (error) => {
              console.error("Error getting location:", error);
              setGeoLocationStatus("error");
            }
          );
        } else {
          alert("Geolocation is not supported by this browser.");
          setGeoLocationStatus("error");
        }
      } else {
        setLocation({
          lat: parseFloat(loc.Lat),
          lng: parseFloat(loc.Lng),
        });
        setGeoLocationStatus("success");
      }
    }
  }, [watch("siteCode"), reloadMap, isOpen]);

  useEffect(() => {
    setValue("lat", location.lat);
    setValue("lng", location.lng);
  }, [location]);

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={onClose}
      sx={{ zIndex: 1300 }}
    >
      <Box
        sx={{
          width: {
            xs: "100vw",
            sm: 598,
          },
        }}
        role="presentation"
      >
        <Typography sx={{ padding: "16px" }}>
          {isEditSiteLocation
            ? `แก้ไขรายการตำแหน่งภายใน SITE ${siteName}`
            : `เพิ่มรายการตำแหน่งภายใน SITE ${siteName}`}
        </Typography>
        {isDrawerFullWidthScreen && (
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
        <Divider />
        <Box
          sx={{
            padding: "16px 24px 16px 24px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{ color: "#637381 !important", fontWeight: 600 }}
          >
            ปักหมุดตำแหน่ง
          </Typography>
          <Controller
            name="siteName"
            control={control}
            render={({ field }) => (
              <TextField
                placeholder="ชื่อตำแหน่ง"
                inputProps={field}
                InputProps={{
                  style: {
                    borderRadius: "10px",
                  },
                }}
                fullWidth
              />
            )}
          />
          {watch("siteName") && (
            <Controller
              name="siteCode"
              control={control}
              render={({ field }) => (
                <TextField
                  placeholder="รหัสตำแหน่ง"
                  inputProps={field}
                  InputProps={{
                    style: {
                      borderRadius: "10px",
                    },
                  }}
                  fullWidth
                />
              )}
            />
          )}
          {watch("siteName") && watch("siteCode") && location && isLoaded && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <PlacesAutoComplete setLocation={setLocation} />
              <Box
                sx={{
                  width: "100%",
                  height: "350px",
                  background: "#ddd",
                  borderRadius: "10px",
                  backgroundColor: "white",
                  // backgroundColor: "#9e9e9e",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {geolocationStatus === "success" ? (
                  <GoogleMap
                    mapContainerStyle={{
                      width: "100%",
                      height: "350px",
                      borderRadius: "10px",
                    }}
                    center={location}
                    onClick={handleMapClick}
                    zoom={15}
                  >
                    <Marker position={location} />
                  </GoogleMap>
                ) : (
                  <div
                    style={{
                      width: "100%",
                      // height: "100%",
                      display: "flex",
                      justifyContent: "center",
                      backgroundColor: "white",
                    }}
                  >
                    <img
                      src={UnicornLoading}
                      alt="Loading..."
                      style={{ width: "300px" }}
                    />
                  </div>
                )}
              </Box>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <>
                  <ButtonBlue
                    startIcon={<RestartAltIcon />}
                    onClick={() => setReloadMap((prev) => !prev)}
                  >
                    Reset
                  </ButtonBlue>
                </>
              </Box>
            </Box>
          )}
          <Box
            sx={{
              display: "flex",
              justifyContent: "end",
              gap: "16px",
            }}
          >
            <ButtonBlue variant="outlined" onClick={onClose}>
              ยกเลิก
            </ButtonBlue>
            <ButtonBlue
              variant="contained"
              onClick={handleSaveSiteLocation}
              disabled={
                watch("siteName") &&
                watch("siteCode") &&
                geolocationStatus === "success"
                  ? false
                  : true
              }
            >
              บันทึกข้อมูล
            </ButtonBlue>
          </Box>
        </Box>
      </Box>
    </Drawer>
  );
};

export default DrawerSiteLocation;
